








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { TimeframeDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxTimeFrame extends Vue {
  private types: TimeframeDto[] | null = [];
  public selectedType = new TimeframeDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: TimeframeDto) {
    this.$emit("timeframeSelected", type);
  }

  public setSelected(type: TimeframeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .timeframe_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
